import styled from "styled-components"
import Title from "../../../common/Title"
import Division from "../../../common/Division"
import SkillBox from "../../../common/SkillBox"
import Content from "../../../common/Content"
import Accordion from "../../../common/Accordion"
import ListItem from "../../../common/ListItem"
import { faHouse } from "@fortawesome/free-solid-svg-icons"
import { faGithub } from "@fortawesome/free-brands-svg-icons"
import ProjectLinkBox from "../../../common/ProjectLinkBox"
import ProjectLink from "../../../common/ProjectLink"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const Box = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export default function LebuBox() {

  return (
    <Box>
      <Title>부산 관광 정보 사이트, LEBU</Title>
      <Division>팀 프로젝트</Division>
      <SkillBox skill={[
        { logo: 'Jquery', content: '제이쿼리(JQuery)', color: '0769AD', },
        { logo: 'JavaScript', content: '자바스크립트(JavaScript)', color: 'F7DF1E', division: true },
        { logo: 'netlify', content: 'Netlify', color: '00C7B7' },
      ]} />
      <Content>
        <Accordion title="개요" open={true}>
          LEBU는 부산의 주요 관광지와 맛집 정보를 제공하는 웹사이트입니다. 실시간 날씨 정보, 다국어 지원을 통해 부산을 방문하는 관광객들에게 유용한 정보를 제공합니다.
        </Accordion>
        <Accordion title="주요 기능 및 역할" open={true}>
          <ListItem>기상청 초단기예보 API를 활용한 실시간 부산 지역 날씨를 제공합니다.</ListItem>
          <ListItem>부산 관광지, 맛집, 행사 정보를 제공합니다.</ListItem>
          <ListItem>한국어 외에도 다국어(중국어, 영어)를 지원합니다.</ListItem>
          <ListItem>Netlify를 이용해 배포하였습니다.</ListItem>
        </Accordion>
      </Content>
      <ProjectLinkBox>
        <ProjectLink href="https://poetic-druid-deac2a.netlify.app/" title="Home">
          <FontAwesomeIcon icon={faHouse} />
        </ProjectLink>
        <ProjectLink href="https://github.com/Leewonno/project1" title="Github">
          <FontAwesomeIcon icon={faGithub} />
        </ProjectLink>
      </ProjectLinkBox>
    </Box>
  )
}

